/* eslint-disable no-unused-vars */
// import axios from 'axios'
import axios from '../../helpers/Axios'
import router from '../../router'

export const companysearchresultmodule = {

    namespaced: true,

    state: {
        loading: false,
        searchResults: [],
        searchResultsAcquisitionHistory: [],
        searchResultsControlSheet: [],
        companySearchResultsId: null,
        resultsPage: 0,
        generalResultsPage: 0,
        dealResultsPage: 0,
        controlSheetResultsPage : 0,
        previousLayout: 1,
        resultsPerPage: 100,
        resultsCount: 0,
        resultsHistoryCount: 0,
        resultsControlSheetCount: 0
    },
    getters: {
        searchResults: state => {
            return state.searchResults;
        },
        searchResultsAcquisitionHistory: state => {
            return state.searchResultsAcquisitionHistory;
        },
        searchResultsControlSheet: state => {
            return state.searchResultsControlSheet;
        },
        resultsCount: state => {
            return state.resultsCount;
        },
        resultsHistoryCount: state => {
            return state.resultsHistoryCount;
        },
        resultsControlSheetCount: state => {
            return state.resultsControlSheetCount;
        },
        resultsPage: state => {
            return state.resultsPage;
        },
        generalResultsPage: state => {
            return state.generalResultsPage;
        },
        dealResultsPage: state => {
            return state.dealResultsPage;
        },
        controlSheetResultsPage: state => {
            console.log("Get Control Sheet Page")
            return state.controlSheetResultsPage;
        },
        previousLayout: state => {
            return state.previousLayout;
        },
        resultsPerPage: state => {
            return state.resultsPerPage;
        },
        loading: state => {
            return state.loading;
        },
        companySearchResultsId: state => {
            return state.companySearchResultsId;
        }
    },
    actions: {

        setLoading({
            commit
        }) {
            commit('updateLoading', true);
        },
        unsetLoading({
            commit
        }) {
            commit('updateLoading', false);
        },

        getCompanySearchResults({
            commit,
            state
        }) {

            console.log('getCompanySearchResults');

            commit('updateLoading', true);

            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache',
                    Pragma: 'no-cache'
                }
            };

            return axios.get('/companysearchresult/get/' + state.companySearchResultsId + '?page=' + state.resultsPage + '&resultsPerPage=' + state.resultsPerPage, config).then(response => {

                commit('updateLoading', false);

                commit('updateSearchResults', response.data.results);
                commit('updateSearchResultsCount', response.data.resultCount);

                console.log('companysearchresult - response.data.resultCount', response.data.resultCount);
            }).catch(err => {
                console.log(err);
            });
        },
        getCompanyControlSheetSearchResults({
            commit,
            state
        }) {

            console.log('getCompanyControlSheetSearchResults');

            commit('updateLoading', true);

            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache',
                    Pragma: 'no-cache'
                }
            };
            console.log("Update control sheet page " + state.controlSheetResultsPage)
            return axios.get('/companysearchresult/getControlSheet/' + state.companySearchResultsId + '?page=' + state.controlSheetResultsPage + '&resultsPerPage=' + state.resultsPerPage, config).then(response => {

                commit('updateLoading', false);

                commit('updateControlSheetSearchResults', response.data.results);
                commit('updateControlSheetSearchResultsCount', response.data.resultCount);

                console.log('companycontrolsheetsearchresult - response.data.resultCount', response.data.resultCount);
            }).catch(err => {
                console.log(err);
            });
        },
        getCompanySearchAcquisitionHistoryResults({
            commit,
            state
        }) {

            commit('updateLoading', true);

            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache',
                    Pragma: 'no-cache'
                }
            };

            return axios.get('/companysearchresult/getAcquisitionHistory/' + state.companySearchResultsId + '?page=' + state.resultsPage + '&resultsPerPage=' + state.resultsPerPage, config).then(response => {

                commit('updateLoading', false);

                commit('updateSearchAcquisitionHistoryResults', response.data.results);
                commit('updateSearchResultsHistoryCount', response.data.resultHistoryCount);

            }).catch(err => {
                console.log(err);
            });
        }
    },
    mutations: {

        updateCompanySearchResultsId(state, id) {
            state.companySearchResultsId = id;
        },
        updateSearchResults(state, results) {
            state.searchResults = results
        },
        updateSearchAcquisitionHistoryResults(state, results) {
            state.searchResultsAcquisitionHistory = results;
        },
        updateControlSheetSearchResults(state, results) {
            state.searchResultsControlSheet = results
        },
        updateResultsPage(state, page) {
            state.resultsPage = page
        },
        updategeneralResultsPage(state, page) {
            state.generalResultsPage = page
        },
        updatedealResultsPage(state, page) {
            state.dealResultsPage = page
        },
        updateControlSheetResultsPage(state, page) {
            console.log("Control Sheet Page updated to " + page)
            state.controlSheetResultsPage = page
        },
        updatepreviousLayout(state, layout) {
            state.previousLayout = layout
        },
        updateSearchResultsCount(state, count) {
            state.resultsCount = count
        },
        updateSearchResultsHistoryCount(state, count) {
            state.resultsHistoryCount = count
        },
        updateControlSheetSearchResultsCount(state, count) {
            state.resultsControlSheetCount = count
        },
        updateLoading(state, loading) {
            state.loading = loading
        }

    }

}
